import React, { useContext } from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import SubNavigation from 'four-nets/ui-v2/sub-navigation/sub-navigation';
import iconClose from 'four-nets/icons/svg/icon_close.svg';
import { AlertContext } from 'lib/alert-context/alert-context';

import AddImages from '../add-images/add-images';
import defaultStyles from './images-edit-header.scss';

interface Props {
    id: string;
    title: string;
    href: string;
    styles: typeof defaultStyles;
    onSubmit: () => void;
    disabled?: boolean;
    dirty?: boolean;
}

const ImagesEditHeader: React.FC<Props> = props => {
    const { confirm } = useContext(AlertContext);
    const history = useHistory();

    const { styles, href, onSubmit, dirty, disabled, title, id } = props;

    const onClick = () => {
        const navigate = () => history.push(href);
        if (dirty) {
            confirm!({
                body: (
                    <>
                        <FormattedMessage id='LEAVE_WITHOUT_SAVING' />?
                    </>
                ),
                onAccept: navigate,
                acceptButtonLabel: <FormattedMessage id='LEAVE' />,
            });
        } else {
            navigate();
        }
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.row}>
                <h1 className={styles.heading}>{title}</h1>
                <div className={styles.controls}>
                    <button disabled={disabled} onClick={onSubmit} className={styles.submitButton}>
                        <FormattedMessage id='SAVE_CHANGES' values={{ gender: 'v' }} />
                    </button>
                    <button onClick={onClick} className={styles.cancelButton}>
                        <SVGIcon style={{ image: styles.iconClose }} className={styles.iconClose} src={iconClose} />
                        <FormattedMessage id='LEAVE_WITHOUT_SAVING' />
                    </button>
                </div>
            </div>
            <SubNavigation
                dirty={dirty}
                links={[
                    { to: `${href}edit-photos/`, label: <FormattedMessage id='EDIT_ALBUM_PHOTOS' /> },
                    {
                        to: `${href}reorder/`,
                        label: <FormattedMessage id='REORDER_PHOTOS' values={{ gender: false }} />,
                    },
                ]}
            />
        </div>
    );
};

export default Styled(defaultStyles)(ImagesEditHeader);
